<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <div class="m-b-24">
        <el-dropdown trigger="click" v-if="this.$hasPerm('B001')" @command="exportCorpus">
          <el-button type="primary">
            语料导出<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="exportCorpusOld">原始语料导出</el-dropdown-item>
            <el-dropdown-item command="exportCorpusNew">替换语料导出</el-dropdown-item>
            <el-dropdown-item command="exportCorpusInteraction">交互语料导出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>&nbsp;&nbsp;
        <!-- <el-button type="primary" size="small" @click="exportCorpusList('old')" v-if="this.$hasPerm('B001')">原始语料导出</el-button>
        <el-button type="primary" size="small" @click="exportCorpusList('new')" v-if="this.$hasPerm('B001')">替换语料导出</el-button> -->
        <el-button type="primary" size="small" @click="clickMarkLabelAssignmentButton"  v-if="this.$hasPerm('Z011')">随机打标</el-button>
        <el-button type="primary" size="small" @click="showSearchs" v-show="showSearch"  v-if="this.$hasPerm('Z011')">显示搜索</el-button>
        <el-button type="primary" size="small" @click="batchUpdateLabelModal = true" v-if="this.$hasPerm('Z012')">批量更新标签</el-button>
         <!-- <el-button type="primary" size="small" @click="test">test</el-button> -->
      </div>
      <div v-show="showAll">
       <el-form size="small" label-width="100px" class="margin15-tb" v-show="ruleSearchShow">
      <el-row :gutter="24">
        <el-col :span="8">
            <el-form-item label="公司:">
              <el-select v-model="alg.companyName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in companyNameList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.companyName"
                  :title="item.companyName">
                  <!-- <template>
                    <span v-if="item.companyName.length > 9">{{item.companyName.substring(0,9) + '...'}}</span>
                    <span v-else>{{item.companyName}}</span>
                  </template> -->
                </el-option>
                <template>
                  <span></span>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="期间:">
              <el-date-picker style="width: 100%;"
                v-model="alg.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="alg.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        <!-- 按钮操作 -->
        <div class="padding15-tb text right">
          <el-button type="primary" @click="searchBtn()" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
          <el-button @click="resetBtn" size="mini">重置</el-button>
          <el-button size="mini" type="text" @click="deploy(true)">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
        </div>
      </el-row>
    </el-form>
      <el-form size="small" label-width="100px" v-show="!ruleSearchShow">
        <!-- 第一行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="公司:">
              <el-select v-model="alg.companyName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in companyNameList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.companyName"
                  :title="item.companyName">
                  <!-- <template>
                    <span v-if="item.companyName.length > 9">{{item.companyName.substring(0,9) + '...'}}</span>
                    <span v-else>{{item.companyName}}</span>
                  </template> -->
                </el-option>
                <template>
                  <span></span>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="期间:">
              <el-date-picker style="width: 100%;"
                v-model="alg.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="alg.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="机器打标:">
              <el-select v-model="alg.markLabelRobot" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in markLabelRobotList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="人工打标:">
              <el-select v-model="alg.markLabelMan" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in markLabelManList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="语料搜索:">
              <el-input placeholder="请输入内容" v-model="alg.markLabelMessage">
                <el-select style="width:80px" v-model="alg.selectType" slot="prepend">
                <el-option label="模糊" value="fuzzy"></el-option>
                <el-option label="精确" value="accurate"></el-option>
              </el-select>
            </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第三行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="打标者:">
              <el-select v-model="alg.labeler" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in labelerList"
                  :key="item.id"
                  :label="item.name +'('+ item.id + ')'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标准语料库:">
              <el-select v-model="alg.standardCorpus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in standardCorpusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="语料ID:">
              <el-input v-model="alg.markLabelId" placeholder="请输入语料ID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第四行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="联系实体:">
              <el-select v-model="alg.telephone" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in telephoneList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="逾期天数:">
              <el-select v-model="alg.overdueDates" clearable collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in overdueDatesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型:">
              <el-select v-model="alg.genreType" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in genreTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第五行 -->
          <el-row :gutter="12">
            <el-col :span="8">
            <el-form-item label="打标状态:">
              <el-select v-model="alg.markLabelStatus" clearable  collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in markLabelStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="打标结果:">
              <el-select v-model="alg.markLabelResult" clearable collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in markLabelResultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上下则机器打标:">
              <el-select v-model="alg.nounMarkLabelRobot" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in nounMarkLabelRobotList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         <el-col :span="12">
            <el-form-item label="置信度">
              <el-col :span="4">
                <el-switch
                  v-model="isSelected">
                </el-switch>
              </el-col>
              <el-col :span="16">
                <transition name="component-fade" mode="out-in">
                  <el-slider v-if="isSelected"
                    v-model="difficultyScore"
                    range
                    :min="0"
                    :max="100">
                  </el-slider>
                </transition>
              </el-col>
            </el-form-item>
          </el-col>
        <!-- 按钮操作 -->
        <div class="padding15-tb text right">
          <el-button type="primary" @click="searchBtn()" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
          <el-button @click="resetBtn" size="mini">重置</el-button>
          <el-button size="mini" type="text" @click="deploy(false)">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
        </div>
      </el-form>
      </div>
    </div>
    <div class="padding15 bg-content">
      <p class="text right">
        <el-button type="success" @click="markLabelButton" v-show="showUpdateTable" plain>修改</el-button>
        <el-button type="primary" @click="showMarkLabel" v-show="showUpdateTable1" plain>保存</el-button>
        <el-button type="danger" @click="outMarkLabel" v-show="showUpdateTable1">退出</el-button>
      </p>
      <br/>
      <br/>
       <el-table
        size="small"
        v-loading="loading"
        :data="list"
        border
        :row-style="{cursor: 'pointer'}"
        highlight-current-row>
        <el-table-column
          property="id"
          label="ID"
          header-align="center"
          key="id"
          width="130px">
        </el-table-column>
        <el-table-column
          property="parentId"
          label="标识"
          header-align="center"
          key="parentId"
          width="130px">
          <template slot-scope="scope">
            <span v-if="scope.row.parentId === null">主句</span>
            <span v-else>{{scope.row.parentId}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="content"
          label="语料"
          key="content"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="contactTypeCode"
          label="对象"
          key="contactTypeCode"
          header-align="center"
          v-if="showUpdateTable">
          <template slot-scope="scope" v-if="showUpdateTable">
            <span v-if="scope.row.contactTypeCode === 'benrendianhua'">本人电话</span>
            <span v-if="scope.row.contactTypeCode === 'zhixidianhua'">直系电话</span>
            <span v-if="scope.row.contactTypeCode === 'feizhixidianhua'">非直系电话</span>
            <span v-if="scope.row.contactTypeCode === null || scope.row.contactTypeCode === ''">--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="keywords"
          label="关键词"
          key="keywords"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="label"
          label="机器打标"
          key="label"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="replyLabel"
          label="计算标签"
          header-align="center"
          key="replyLabel"
          v-if="showUpdateTable">
        </el-table-column>
        <el-table-column
          property="telephone"
          label="联系实体"
          key="telephone"
          width="50px"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="amount"
          label="金额实体"
          key="amount"
          width="50px"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="promisePayTime"
          label="承诺还款时间"
          key="promisePayTime"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="timeEntity"
          label="时间实体"
          key="timeEntity"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="overdueDates"
          label="逾期天数"
          key="overdueDates"
          header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.overdueDates === null">--</span>
            <span v-else-if="scope.row.overdueDates <= 0">预提醒</span>
            <span v-else-if="scope.row.overdueDates > 0 && scope.row.overdueDates <= 7">逾期1周</span>
            <span v-else-if="scope.row.overdueDates > 7 && scope.row.overdueDates <= 30">M1</span>
            <span v-else-if="scope.row.overdueDates > 30 && scope.row.overdueDates <= 60">M2</span>
            <span v-else-if="scope.row.overdueDates > 60">M3</span>
          </template>
        </el-table-column>
        <el-table-column
          property="createTime"
          label="创建时间"
          key="createTime"
          header-align="center"
          width="90px">
        </el-table-column>
        <el-table-column
          property="lastLabel"
          label="上则打标"
          key="lastLabel"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="lastContent"
          label="上则语料"
          key="lastContent"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="modifiedLabel"
          label="人工打标"
          key="modifiedLabel"
          header-align="center">
        </el-table-column>
        <el-table-column
          property="markUserName"
          label="打标者"
          key="markUserName"
          header-align="center"
          width="100px">
        </el-table-column>
        <el-table-column
          property="status"
          label="剔除"
          key="status"
          header-align="center"
          width="50px">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.status" @change="updateLabelStatus(scope.row.id,scope.row.status)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          property="standardCorpus"
          label="标准语料"
          key="standardCorpus"
          header-align="center"
          width="50px">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.standardCorpus" @change="updateLabelStandardCorpus(scope.row.id,scope.row.standardCorpus)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          property="confidence"
          label="置信度"
          key="confidence"
          header-align="center"
          width="50px"
          v-if="showUpdateTable">
        </el-table-column>
        <el-table-column
          property="id"
          label="操作"
          key="ids"
          width="180px"
          header-align="center"
          v-if="fsnumShow">
          <template slot-scope="scope">
            <!-- <template v-if="fsnumShow"> -->
              <el-dropdown size="mini" @command="modiflyLabel" trigger="click">
                <el-button type="primary" size="mini" plain>
                  修改<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <div v-for="item in markLabelManList" :key="item.id">
                    <el-dropdown-item :command="{type: item.name, id: scope.row.id }">{{item.name}}</el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              &nbsp;
              <el-button type="success" @click="sureLabel(scope.row)" size="mini" plain>正确</el-button>
            <!-- </template> -->
          </template>
        </el-table-column>
       </el-table>
       <div class="text center margin15-tb">
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :page-sizes="[20, 50, 100, 200]"
            :total="markLabelreq.totalRecords"
            :page-size="searchReq.limit"
            :current-page="searchReq.page"
            @current-change="currentChange"
            @size-change="sizeChange">
          </el-pagination>
        </div>
    </div>
    <!-- 弹框 -->
    <div class="dialog">
      <el-dialog
        title="批量更新标签"
        :visible.sync="batchUpdateLabelModal"
        width="30%"
        center>
        <el-form label-width="160px">
          <el-form-item label="更新人工标签为:">
            <el-select v-model="labelName" collapse-tags placeholder="请选择">
                <el-option
                  v-for="item in labelNameList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="batchUpdateLabelStatus" size="small">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fsnumShow: false,
      showUpdateTable: true,
      showUpdateTable1: false,
      showSearch: false,
      showAll: true,
      alg: {
        companyName: [],
        startTime: '',
        endTime: '',
        markLabelStatus: '',
        markLabelResult: '',
        markLabelMessage: '',
        markLabelRobot: [],
        markLabelMan: [],
        genreType: [],
        labeler: [],
        nounMarkLabelRobot: [],
        telephone: [],
        standardCorpus: [],
        markLabelId: '',
        overdueDates: '',
        selectType: 'fuzzy'
      },
      loading: false,
      isSelected: false,
      difficultyScore: [25, 75],
      companyNameList: [],
      markLabelStatusList: [{
        value: '1',
        label: '已打标'
      },
      {
        value: '2',
        label: '未打标'
      }],
      markLabelResultList: [{
        value: 'true',
        label: '人工打标与机器打标相同'
      },
      {
        value: 'false',
        label: '人工打标与机器打标不同'
      }],
      markLabelRobotList: [],
      markLabelManList: [],
      genreTypeList: [{
        value: 'matrix',
        label: '主句'
      },
      {
        value: 'clause',
        label: '子句'
      }],
      labelerList: [],
      nounMarkLabelRobotList: [{
        value: 'identical',
        label: '与人工一致'
      },
      {
        value: 'noIdentical',
        label: '与人工不一致'
      }],
      telephoneList: [{
        value: 'yTelephone',
        label: '有联系实体'
      },
      {
        value: 'nTelephone',
        label: '无联系实体'
      }],
      standardCorpusList: [{
        value: 'yStandardCorpus',
        label: '标准语料'
      },
      {
        value: 'nStandardCorpus',
        label: '非标准语料'
      }],
      overdueDatesList: [{
        value: 'overdueDates_one',
        label: '预提醒'
      },
      {
        value: 'overdueDates_two',
        label: '逾期一周'
      }, {
        value: 'overdueDates_three',
        label: 'M1'
      },
      {
        value: 'overdueDates_four',
        label: 'M2'
      },
      {
        value: 'overdueDates_five',
        label: 'M3'
      }],
      ruleSearchShow: true,
      list: [],
      markLabelreq: { totalRecords: 0, list: [] },
      searchReq: {
        page: 1,
        limit: 50
      },
      map: {},
      labelName: '',
      labelNameList: [],
      batchUpdateLabelModal: false,
      exportTimeData: ''
    };
  },
  // 进入页面调用此方法
  mounted() {
    this.SetSeeion();
    // this.searchBtn();
    this.getCompanyAll();
    this.initMarkLabelRobot();
    this.initLabeler();
  },
  methods: {
    test() {
      this.$ajax({
        url: '/markLabel/test'
      }).then((res) => {
        console.warn(res);
      });
    },
    deploy(dp) {
      this.ruleSearchShow = !dp;
    },
    currentChange(page) {
      console.warn('选页');
      this.searchReq.page = page;
      this.getMarkLabelList();
    },
    // 显示条数
    sizeChange(num) {
      console.warn('每页条数');
      this.searchReq.limit = num;
      this.getMarkLabelList();
    },
    // 修改
    markLabelButton() {
      this.fsnumShow = true;
      this.showUpdateTable = false;
      this.showUpdateTable1 = true;
    },
    // 正确
    sureLabel(type) {
      console.warn(type);
      const list = this.list;
      list.forEach((ll) => {
        if (ll.id === type.id) {
          ll.modifiedLabel = ll.label;
        }
      });
      const map = this.map;
      map[type.id] = type.modifiedLabel;
      console.warn(map);
    },
    // 退出
    outMarkLabel() {
      if (JSON.stringify(this.map) !== '{}') {
        this.$confirm('将退出人工打标页面，确定不保存已修改的打标结果吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.warn(this.map);
          this.fsnumShow = false;
          this.showUpdateTable = true;
          this.showUpdateTable1 = false;
          this.map = {};
          if (this.showSearch) {
            this.getMarkLabelList('markLabelAssignment');
          } else {
            this.getMarkLabelList();
          }
        });
      } else {
        this.fsnumShow = false;
        this.showUpdateTable = true;
        this.showUpdateTable1 = false;
        if (this.showSearch) {
          this.getMarkLabelList('markLabelAssignment');
        } else {
          this.getMarkLabelList();
        }
      }
    },
    //  修改
    modiflyLabel(val) {
      console.warn(val);
      const list = this.list;
      list.forEach((ll) => {
        if (ll.id === val.id) {
          ll.modifiedLabel = val.type;
        }
      });
      const map = this.map;
      map[val.id] = val.type;
      console.warn(map);
    },
    // 保存按钮
    showMarkLabel() {
      const map = this.map;
      console.warn(map);
      console.warn(JSON.stringify(map));
      if (JSON.stringify(map) === '{}') {
        this.$message({
          type: 'error',
          message: '此次保存未做任何更改，请修改后再点击保存'
        });
        return;
      }
      const types = 'saveMarkLabelAssignment';
      this.$ajax({
        prompt: true,
        url: '/markLabel/modifyLabel',
        params: { detail: JSON.stringify(map), type: types }
      }).then((res) => {
        console.warn(res);
        this.map = {};
      });
    },
    searchBtn() {
      this.searchReq.page = 1;
      this.getMarkLabelList();
    },
    // 搜索
    getMarkLabelList(type) {
      this.map = {};
      this.loading = true;
      const search = this.getSearch();
      search.page = this.searchReq.page;
      search.limit = this.searchReq.limit;
      if (type !== undefined) {
        search.markLabelAssignment = type;
      }
      // 判断时间
      const startTime = this.alg.startTime;
      const endTime = this.alg.endTime;
      if (startTime != null && endTime != null) {
        if (new Date(startTime) > new Date(endTime)) {
          this.$message({
            type: 'error',
            message: '开始时间不能大于结束时间'
          });
          this.loading = false;
          return;
        }
      }
      // 缓存置空
      sessionStorage.setItem('robotMarkLabelSearch', null);
      // 搜索条件写入缓存
      sessionStorage.setItem('robotMarkLabelSearch', JSON.stringify(search));
      this.$ajax({
        url: '/markLabel/getLabelList',
        data: search
      }).then((res) => {
        console.warn(res);
        this.list = res.data.list;
        this.markLabelreq.totalRecords = res.data.totalRecords;
        this.loading = false;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 重置按钮
    resetBtn() {
      this.alg.companyName = [];
      this.alg.startTime = '';
      this.alg.endTime = '';
      this.alg.markLabelStatus = '';
      this.alg.markLabelResult = '';
      this.alg.markLabelMessage = '';
      this.alg.markLabelRobot = [];
      this.alg.markLabelMan = [];
      this.alg.genreType = [];
      this.alg.labeler = [];
      this.alg.nounMarkLabelRobot = [];
      this.alg.telephone = [];
      this.alg.standardCorpus = [];
      this.alg.markLabelId = '';
      this.alg.overdueDates = '';
      this.alg.selectType = 'fuzzy';
      this.isSelected = false;
    },
    // 获取搜索条件
    getSearch() {
      console.warn('获取搜索条件');
      const query = {};
      if (this.alg.companyName.join(',') !== '' && this.alg.companyName.join(',') !== null) {
        query.companyName = this.alg.companyName.join(',');
      }
      if (this.alg.startTime !== '' && this.alg.startTime !== null) {
        query.startTime = this.alg.startTime;
      }
      if (this.alg.endTime !== '' && this.alg.endTime !== null) {
        query.endTime = this.alg.endTime;
      }
      if (this.alg.markLabelRobot.join(',') !== '' && this.alg.markLabelRobot.join(',') !== null) {
        query.markLabelRobot = this.alg.markLabelRobot.join(',');
      }
      if (this.alg.markLabelMan.join(',') !== '' && this.alg.markLabelMan.join(',') !== null) {
        query.markLabelMan = this.alg.markLabelMan.join(',');
      }
      if (this.alg.selectType !== '' && this.alg.selectType !== null) {
        query.selectType = this.alg.selectType;
      }
      if (this.alg.markLabelMessage !== '' && this.alg.markLabelMessage !== null) {
        query.markLabelMessage = this.alg.markLabelMessage;
      }
      if (this.alg.labeler.join(',') !== '' && this.alg.labeler.join(',') !== null) {
        query.labeler = this.alg.labeler.join(',');
      }
      if (this.alg.standardCorpus.join(',') !== '' && this.alg.standardCorpus.join(',') !== null) {
        query.standardCorpus = this.alg.standardCorpus.join(',');
      }
      if (this.alg.markLabelId !== '' && this.alg.markLabelId !== null) {
        query.id = this.alg.markLabelId;
      }
      if (this.alg.telephone.join(',') && this.alg.telephone.join(',') !== null) {
        query.telephone = this.alg.telephone.join(',');
      }
      if (this.alg.overdueDates && this.alg.overdueDates !== null) {
        query.overdueDates = this.alg.overdueDates;
      }
      if (this.alg.genreType.join(',') && this.alg.genreType.join(',') !== null) {
        query.genreType = this.alg.genreType.join(',');
      }
      if (this.alg.markLabelStatus && this.alg.markLabelStatus !== null) {
        query.markLabelStatus = this.alg.markLabelStatus;
      }
      if (this.alg.markLabelResult && this.alg.markLabelResult !== null) {
        query.markLabelResult = this.alg.markLabelResult;
      }
      if (this.alg.nounMarkLabelRobot.join(',') && this.alg.nounMarkLabelRobot.join(',') !== null) {
        query.nounMarkLabelRobot = this.alg.nounMarkLabelRobot.join(',');
      }
      if (this.isSelected) {
        query.confidence = this.difficultyScore.join(',');
      }
      console.warn(query);
      return query;
    },
    SetSeeion() {
      // 读取缓存数据
      const session = JSON.parse(sessionStorage.getItem('robotMarkLabelSearch'));
      console.warn(session);
      if (session != null) { // 有缓存
        if (session.companyName !== undefined) {
          const aa = session.companyName.split(',');
          const bb = [];
          aa.forEach((a) => {
            console.warn(a);
            bb.push(Number(a));
          });
          this.alg.companyName = bb;
        }
        if (session.startTime !== undefined) {
          this.alg.startTime = session.startTime;
        }
        if (session.endTime !== undefined) {
          this.alg.endTime = session.endTime;
        }
        if (session.markLabelRobot !== undefined) {
          this.alg.markLabelRobot = session.markLabelRobot.split(',');
        }
        if (session.markLabelMan !== undefined) {
          this.alg.markLabelMan = session.markLabelMan.split(',');
        }
        if (session.selectType !== undefined) {
          this.alg.selectType = session.selectType;
        }
        if (session.markLabelMessage !== undefined) {
          this.alg.markLabelMessage = session.markLabelMessage;
        }
        if (session.labeler !== undefined) {
          const aa = session.labeler.split(',');
          const bb = [];
          aa.forEach((a) => {
            console.warn(a);
            bb.push(Number(a));
          });
          this.alg.labeler = bb;
        }
        if (session.standardCorpus !== undefined) {
          this.alg.standardCorpus = session.standardCorpus.split(',');
        }
        if (session.id !== undefined) {
          this.alg.markLabelId = Number(session.id);
        }
        if (session.telephone !== undefined) {
          this.alg.telephone = session.telephone.split(',');
        }
        if (session.overdueDates !== undefined) {
          this.alg.overdueDates = session.overdueDates;
        }
        if (session.genreType !== undefined) {
          this.alg.genreType = session.genreType.split(',');
        }
        if (session.markLabelStatus !== undefined) {
          this.alg.markLabelStatus = session.markLabelStatus;
        }
        if (session.markLabelResult !== undefined) {
          this.alg.markLabelResult = session.markLabelResult;
        }
        if (session.nounMarkLabelRobot !== undefined) {
          this.alg.nounMarkLabelRobot = session.nounMarkLabelRobot.split(',');
        }
        if (session.isSelected !== undefined) {
          this.isSelected = session.isSelected;
        }
      }
    },
    // 获取公司下拉框
    getCompanyAll() {
      this.$ajax({
        url: '/markLabel/getCompanyName'
      }).then((res) => {
        console.warn(res);
        this.companyNameList = res.data;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 获取 机器/人工 打标
    initMarkLabelRobot() {
      this.$ajax({
        url: '/markLabel/getMarkLabelRobot'
      }).then((res) => {
        console.warn(res);
        this.markLabelRobotList = res.data;
        this.markLabelManList = res.data;
        this.labelNameList = res.data;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 获取打标者
    initLabeler() {
      this.$ajax({
        url: '/markLabel/getLabeler'
      }).then((res) => {
        console.warn(res);
        this.labelerList = res.data;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    updateLabelStatus(id, vue) {
      console.warn('剔除');
      if (vue) {
        vue = false;
      } else {
        vue = true;
      }
      this.$ajax({
        prompt: true,
        url: '/markLabel/updateLabelStatus',
        params: { ids: id, status: vue }
      });
    },
    updateLabelStandardCorpus(id, vue) {
      console.warn('剔除');
      this.$ajax({
        prompt: true,
        url: '/markLabel/updateLabelStandardCorpus',
        params: { ids: id, standardCorpus: vue }
      });
    },
    exportCorpus(command) {
      if (command === 'exportCorpusOld') {
        this.exportCorpusList('old');
      }
      if (command === 'exportCorpusNew') {
        this.exportCorpusList('new');
      }
      if (command === 'exportCorpusInteraction') {
        this.exportCorpusInteraction();
      }
    },
    exportCorpusInteraction() {
      console.warn('导出交互');
      const nowLong = new Date().getTime();
      if (this.exportTimeData && (nowLong - this.exportTimeData.getTime()) < 1000 * 60 * 10) {
        this.$message({
          message: '您已经生成过了，休息几分钟再生成数据吧',
          type: 'warning'
        });
        return;
      }
      const countAll = this.markLabelreq.totalRecords;
      if (countAll === 0) {
        this.$message({
          type: 'error',
          message: '没有语料可以导出，请重新选择!'
        });
        return;
      }
      const startTime = this.alg.startTime;
      const endTime = this.alg.endTime;
      if (!startTime) {
        this.$message({
          type: 'error',
          message: '请选择时间范围!'
        });
        return;
      }
      if (startTime && endTime) {
        const t = (new Date(startTime.replace(/-/g, '/'))).getTime();
        const e = (new Date(endTime.replace(/-/g, '/'))).getTime();
        const day = Math.floor((e - t) / (24 * 3600 * 1000));
        console.warn(day);
        if (day > 30) {
          this.$message({
            type: 'error',
            message: '不能导出超过一个月的数据!'
          });
          return;
        }
      }
      if (startTime && !endTime) {
        const t = (new Date(startTime.replace(/-/g, '/'))).getTime();
        const newTime = (new Date()).getTime();
        const day = Math.floor((newTime - t) / (24 * 3600 * 1000));
        if (day > 30) {
          this.$message({
            type: 'error',
            message: '不能导出超过一个月的数据!'
          });
          return;
        }
      }
      const search = this.getSearch();
      this.exportTimeData = new Date();
      this.$ajax({
        url: '/markLabel/exportCorpusInteractions',
        data: search
      }).then(() => {
        this.$message({
          message: '交互语料将会与今天晚上八点发送到您的邮箱，请注意查收!',
          type: 'success'
        });
      });
    },
    // 导出语料
    exportCorpusList(type) {
      console.warn('导出语料');
      const countAll = this.markLabelreq.totalRecords;
      console.warn(countAll);
      if (countAll === 0) {
        this.$message({
          type: 'error',
          message: '没有语料可以导出，请重新选择！'
        });
        return;
      }
      console.warn(type);
      const search = this.getSearch();
      console.warn(search);
      search.excelToken = localStorage.getItem('authorization');
      search.excelType = type;
      console.warn($.param(search));
      // const fileUrl = `/webapi/v1/markLabel/exportCorpusList?markLabelReq=${$.param(search)}`;
      const fileUrl = '/webapi/v1/markLabel/exportCorpusList';
      console.warn(fileUrl);
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(search).forEach((key) => {
        const input = document.createElement('input');
        input.setAttribute('name', key);
        input.setAttribute('value', search[key]);
        input.style.display = 'none';
        form.appendChild(input);
      });
      form.submit();
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        console.warn(parent);
        document.body.removeChild(form);
      }, 1000);
    },
    // 随机打标
    clickMarkLabelAssignmentButton() {
      this.showSearch = true;
      this.showAll = false;
      this.getMarkLabelList('markLabelAssignment');
    },
    showSearchs() {
      this.showSearch = false;
      this.showAll = true;
    },
    // 批量更新标签
    batchUpdateLabelStatus() {
      console.warn('批量更新标签');
      const labelName = this.labelName;
      console.warn(labelName);
      if (labelName === null || labelName === '') {
        this.$message({
          type: 'error',
          message: '请选择标签！'
        });
        return;
      }
      const countAll = this.markLabelreq.totalRecords;
      console.warn(countAll);
      if (countAll === 0) {
        this.$message({
          type: 'error',
          message: '当前没有语料可以更新！'
        });
      } else if (countAll >= 10000) {
        this.$message({
          type: 'error',
          message: '您无法更新超过10000条语料，请缩小筛选范围!'
        });
      } else if (countAll < 10000) {
        this.$confirm(`您将${countAll}个语料标签更新为${labelName},确定是否要更新，一旦更新将无法复原。`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 更新
          const search = this.getSearch();
          search.labelName = labelName;
          this.$ajax({
            prompt: true,
            url: '/markLabel/batchUpdateLabel',
            data: search
          }).then((res) => {
            console.warn(res);
            this.batchUpdateLabelModal = false;
            this.getMarkLabelList();
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消更新'
          });
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/algCorpus/robotMarkLabel.vue